export default __webpack_public_path__ + "static/media/volume-gestalt.68812c2c.svg";